import React, { useState, useEffect } from "react";
import "../../Styles/PC/WellnessProfessionals.css";

import {
    Add,
    Delete,
    Mail,
    Phone,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import {
    getWellnessProfessionalsAPI,
    searchDoctorsForWellnessAPI,
    addProfessionalsAPI,
    deleteProfessionalByIdAPI
} from "../../services/pcConfigService";



const WellnessProfessionals = () => {
    const [professionals, setProfessionals] = useState([]);
    const [open, setOpen] = useState(false);
    const [editing, setEditing] = useState(null);

    const [doctorResults, setDoctorResults] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedDoctor, setSelectedDoctor] = useState(null);

    const emptyForm = {
        name: "",
        speciality: "",
        phone: "",
        email: "",
        isAvailable: true,
    };

    const [formData, setFormData] = useState(emptyForm);

    useEffect(() => {
        fetchProfessionals();
    }, []);

    const fetchProfessionals = async () => {
        const response = await getWellnessProfessionalsAPI();
        console.log('professionals', response)
        if (response?.count > 0) {
            setProfessionals(response?.professionals);
        } else {
            setProfessionals([]);
        }
    };

    /* ================= SEARCH DOCTORS ================= */

    const handleDoctorSearch = async (value) => {
        setSearchText(value);

        if (value.length < 2) {
            setDoctorResults([]);
            return;
        }

        try {
            const response = await searchDoctorsForWellnessAPI(value);
            // const response = await axios.get(
            //     `/doctor/searchDoctorsForWellness?searchText=${value}`
            // );
            if (response?.doctors.length > 0) {
                response.doctors.forEach((doctor) => {
                    doctor.specialization = doctor.specialization[0];
                });
                setDoctorResults(response?.doctors || []);
            } else {
                setDoctorResults([]);
            }
        } catch (error) {
            console.error("Doctor search error:", error);
            setDoctorResults([]);
        }
    };

    const handleSelectDoctor = (doctor) => {
        console.log('doctorselected', doctor)
        setSelectedDoctor(doctor);
    };

    /* ================= ADD ================= */

    const handleOpenAdd = () => {
        setEditing(null);
        setFormData(emptyForm);
        setSearchText("");
        setDoctorResults([]);
        setOpen(true);
    };

    const handleDoctorSave = async () => {


        if (editing) {
            setProfessionals((prev) =>
                prev.map((p) =>
                    p.id === editing.id ? { ...p, ...formData } : p
                )
            );
        } else {
            console.log('selectedDoctor', selectedDoctor);
            const response = await addProfessionalsAPI(selectedDoctor);
            console.log('addeddoctor', response)
            if (response?.status == 'success') {
                toast.success(response?.message);
                fetchProfessionals();
            } else {
                toast.error(response?.message);
            }
        }

        setOpen(false);
    };

    const handleDelete = async (id) => {
        console.log('deleteddoctorid', id);
        let obj = {
            _id: id
        }
        const response = await deleteProfessionalByIdAPI(obj);
        console.log('deleteddoctor', response)
        if (response?.status == 'success') {
            toast.success(response?.message);
            fetchProfessionals();
        } else {
            toast.error(response?.message);
        }
    };

    const handleToggle = (id) => {
        setProfessionals((prev) =>
            prev.map((p) =>
                p.id === id ? { ...p, isAvailable: !p.isAvailable } : p
            )
        );
    };

    const getInitials = (name) =>
        name
            ?.split(" ")
            ?.map((n) => n[0])
            ?.join("")
            ?.toUpperCase();

    return (
        <div className="wp-container">

            <div className="wp-header">
                <div>
                    <h2>Healthcare Professionals</h2>
                    <p>Manage doctors, dieticians, and fitness counsellors</p>
                </div>

                <button className="primary-btn" onClick={handleOpenAdd}>
                    <Add fontSize="small" /> Add Professional
                </button>
            </div>

            {/* Cards */}
            <div className="wp-grid">
                {professionals.map((prof) => (
                    <div className="prof-card" key={prof._id}>
                        <div className="prof-header">
                            <div className="avatar">
                                {getInitials(prof.fullName)}
                            </div>

                            <div>
                                <div className="prof-name">{prof.fullName}</div>
                                <div className="prof-type">{prof.specialization}</div>
                            </div>

                            {/* <div className={`status ${prof.isAvailable ? "available" : "unavailable"}`}>
                                {prof.isAvailable ? "Available" : "Unavailable"}
                            </div> */}
                        </div>

                        <div className="prof-contact">
                            <div><Mail fontSize="small" /> {prof.email}</div>
                            <div><Phone fontSize="small" /> {prof.phoneNumber}</div>
                        </div>

                        <div className="prof-actions">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={true}
                                    disabled={true}
                                />
                                <span className="slider"></span>
                            </label>

                            <button
                                className="icon-btn delete"
                                onClick={() => handleDelete(prof._id)}
                            >
                                <Delete />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal */}
            {open && (
                <div className="wps-modal-overlay">
                    <div className="wps-modal">
                        <h3>Add Professional</h3>

                        <div className="wps-row">
                            <div className="wps-col-6">
                                <input
                                    placeholder="Search Doctor Name"
                                    value={searchText}
                                    onChange={(e) =>
                                        handleDoctorSearch(e.target.value)
                                    }
                                />
                            </div>
                        </div>

                        {/* Doctor Search Results Cards */}
                        {doctorResults.length > 0 && (
                            <div className="modal-prof-card-row" >
                                {doctorResults.map((doc) => (
                                    <div
                                        key={doc._id}
                                        className={`modal-prof-card ${selectedDoctor?._id === doc._id ? "selected-card" : ""}`}
                                        onClick={() => handleSelectDoctor(doc)}
                                    >
                                        <div className="modal-prof-header">
                                            <div className="avatar">
                                                {getInitials(doc.fullName)}
                                            </div>

                                            <div>
                                                <div className="modal-prof-name">
                                                    {doc.fullName}
                                                </div>
                                                <div className="modal-prof-type">
                                                    {doc.specialization}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="prof-contact">
                                            <div><Mail fontSize="small" /> {doc.email}</div>
                                            <div><Phone fontSize="small" /> {doc.phoneNumber}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="wps-modal-actions">
                            <button
                                className="secondary-btn"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="primary-btn"
                                onClick={handleDoctorSave}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WellnessProfessionals;
